/**
 * Un usado es un EQUIPO o un RENGLON DE LA LISTA, y esta es la unica forma de
 * saber cual.
 *
 *   · El renglon de la lista —"IPHONE 13 128 GB (USADO)"— dice cuanto vale ese
 *     modelo usado. No es ningun telefono: no tiene bateria ni IMEI, no tiene
 *     stock, y en cero se ofrece a pedido.
 *   · El equipo es un telefono concreto, con su bateria medida y, si se pudo
 *     leer, su IMEI. Tiene precio propio y hay uno solo: stock 0 o 1.
 *
 * La bateria alcanza para decir que es un equipo: se mide con el aparato en la
 * mano. El IMEI solo no alcanza porque los equipos del proveedor no lo tienen.
 *
 * Antes cada capa contestaba esto a su manera —la web miraba solo el IMEI, la
 * pantalla interna bateria o IMEI— y un mismo telefono era un equipo adentro y
 * un renglon de la lista afuera. La base usa la misma regla en
 * `es_unidad_usada()` (migracion 0092): si cambia una, cambia la otra.
 *
 * Los sellados no entran: un sellado de color es un casillero de stock, no un
 * telefono unico.
 */

export interface DatosDeUsado {
  es_usado: boolean;
  imei: string | null;
  bateria_pct: number | null;
}

/** Un telefono concreto: bateria o IMEI. */
export function esUnidadUsada(p: DatosDeUsado): boolean {
  return p.es_usado && (p.imei !== null || p.bateria_pct !== null);
}

/** Un renglon de la lista de precios de usados: ni bateria ni IMEI. */
export function esReferenciaUsada(p: DatosDeUsado): boolean {
  return p.es_usado && p.imei === null && p.bateria_pct === null;
}
